/*
 * @Descripttion: 在线申请处方弹窗
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2026-09-21
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Col,
  Form,
  Input,
  Menu,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Tag,
  Dropdown,
  Cascader as Cascaded,
  Progress,
  Button,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { ThemeContext } from "../../theme/ThemeContext"
import { DateTimeFormatSimple } from "../../models/datetime"
import { getHistoryDataFn, getPrescriptionAuditAsync } from "./PharmacyRetailSlice"
import styles from '../retail/Retail.module.css'
import { DiseaseInput } from "../../compnents/input/DiseaseInput"
import { Disease } from "../../models/disease"
import { CloseCircleFilled, CloseOutlined, SearchOutlined } from "@ant-design/icons"
import { FastInput } from "../treatment/tcmCases/fastInput"
import { getAddress, getPatientPageInfo, getPatientList, selectPatients } from "../registration/register/registerSlice"
import { Gender, getGenderName } from "../../models/user"
import { getAge } from "../../utils/StringUtils"
import { getPrintTemplateSettingUserList } from "../print/printSlice"
import { selectSettings } from "../user/setting/settingSlice"
import { Checks, getChannelName } from "../../models/setting"
import { getMaskIdCard, getMaskPhone } from "../../models/phone"
import { getCheckPermissionAsync } from "../FunctionSetting/dataPermission/dataPermissionSlice"
import { SJQXChecks } from "../../models/dataPersion"
import { selectCredentials } from "../../app/applicationSlice"
const { Option } = Select
const { TextArea } = Input
const { CheckableTag } = Tag

interface OnlineInformationModalProps {
  visible: boolean
  patientId: number
  patientObj: any
  // 详情接口返回的 { order, treatment }，失败后重新申请时用于回填
  detailData?: any
  // 申请结果回调：failed=true 表示申请失败（需记录标志，供下次预结算时调详情接口回填）
  onApplyResult?: (failed: boolean) => void
  onCancel: () => void
  onOk: (data: any) => Promise<any> // 提交处方申请接口，返回 Promise
  onClose?: () => void // 用户主动关闭弹窗（点取消/关闭）时回调，用于清空页面数据
  handlePay: () => void
}

export const OnlineInformationModal = ({
  visible,
  patientId,
  patientObj,
  detailData,
  onApplyResult,
  onCancel,
  onOk,
  onClose,
  handlePay,
}: OnlineInformationModalProps): ReactElement => {
  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 16 },
  }

  const layouts = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }

  const patientSystolicPressureRef = useRef<any>(null)

  const patientDiastolicPressureRef = useRef<any>(null)

  const patientPulseRef = useRef<any>(null)

  const patientHeightRef = useRef<any>(null)

  const patientWeightRef = useRef<any>(null)

  const otherPhysicalRef = useRef<any>(null)

  // 标记提交失败后"立即修改"重新打开：跳过表单重置与患者信息回填，保留已填内容
  const preserveFormRef = useRef(false)

  const [deleteFlag, setDeleteFlag] = useState<any>(false)

  const [patientSystolicPressureValue, setPatientSystolicPressureValue] = useState<any>()

  const [patientDiastolicPressureValue, setPatientDiastolicPressureValue] = useState<any>()

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [disable, setDisable] = useState(false)

  const [keyword, setKeyword] = useState('')

  const [users, setUsers] = useState<any>([])

  const patients = useSelector(selectPatients)

  const settings = useSelector(selectSettings)

  const credentials = useSelector(selectCredentials)

  // 互联网医院申请渠道：开关 170 返回的结构体里包含 KJ 才展示渠道名称
  const internetChannelConfig = settings?.[170]

  const [isPatientOverlayVisible, setIsPatientOverlayVisible] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [Auditform] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [selectedDiseases, setSelectedDiseases] = useState<Disease[]>([])

  const [maskInfo, setMaskInfo] = useState<any>({})

  const [ageYears, setAgeYear] = useState<any>()

  const [ageMonths, setAgeMonth] = useState<any>()

  const [ageDays, setAgeDay] = useState<any>()

  const [sex, setSex] = useState<any>()

  // 当前选中的患者 id（下拉选中或 patientObj 回填），保存时作为 patient.id 传给后端
  const [selectedPatientId, setSelectedPatientId] = useState<any>()

  const [idCardInputValid, setIdCardInputValid] = useState(false)

  const [btnLoading, setBtnLoading] = useState(false)

  const [payLoading, setPayLoading] = useState(false)

  // ========== 新增状态：处方申请流程弹窗状态 ==========
  const [showApplyProgressModal, setShowApplyProgressModal] = useState(false) //处方申请中弹窗

  const [progressPercent, setProgressPercent] = useState(0) //进度条百分比

  const [showFailModal, setShowFailModal] = useState(false) //申请失败弹窗

  const [failReason, setFailReason] = useState('') //失败原因

  const [showPrescriptionDetailModal, setShowPrescriptionDetailModal] = useState(false) //处方详情弹窗

  const [showPrescriptionAuditModal, setShowPrescriptionAuditModal] = useState(false) //处方审核弹窗

  const [buttonLoading, setButtonLoading] = useState(false)

  const [prescriptionPdfBase64, setPrescriptionPdfBase64] = useState('') //第三方回传的处方笺 base64

  const [prescriptionNo, setPrescriptionNo] = useState('') //处方编号

  const [KSKDCKHRSJHData, setKSKDCKHRSJHData] = useState<any>(true)

  const [KSKDCKHRSFZHData, setKSKDCKHRSFZHData] = useState<any>(true)

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '身份证格式错误',
    },
    {
      max: 18,
      message: '最长18位!',
    },
  ])


  const provinceCode = credentials?.tenantProvinceCode
    ? Number(credentials?.tenantProvinceCode + '000000')
    : ''
  const cityCode = credentials?.tenantCityCode
    ? Number(credentials?.tenantCityCode + '000000')
    : ''
  const countyCode = credentials?.tenantCountyCode
    ? Number(credentials?.tenantCountyCode + '000000')
    : ''

  // 获取挂号查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KSKDCKHRSJH }))
      .then(unwrapResult)
      .then((res: any) => {
        setKSKDCKHRSJHData(res)
      })
    // 获取挂号查看患者身份证号数据权限
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KSKDCKHZSFZH }))
      .then(unwrapResult)
      .then((res: any) => {
        setKSKDCKHRSFZHData(res)
      })
  }

  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const getIdCardInfo = (idCard: string) => {
    const date = new Date()
    const getMonth = date.getMonth() + 1 //当前月份
    const getDay = date.getDate() //当前日期
    const getFullYear = date.getFullYear() //当前年份

    let month = 0
    let year = 0
    let day = 0
    let birthday = ''
    //  身份证上的年月日
    if (idCard) {
      //先判断是不是中国大陆身份证
      if (
        (idCard.length != 15 && idCard.length != 16 && idCard.length != 18) ||
        isNaN(Number(idCard.substr(0, 6)))
      ) {
        setIdCardInputValid(false)
        setIdCardRules([
          {
            max: 18,
            message: '最长18位!',
          },
        ])
      } else {
        setIdCardInputValid(true)
        setIdCardRules([
          {
            pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证格式错误',
          },
          {
            max: 18,
            message: '最长18位!',
          },
        ])
        const sex = Number(idCard?.[idCard?.length - 2]) % 2 == 0 ? 2 : 1
        if (idCard.length === 18) {
          month = parseInt(idCard?.substr(10, 2)) //身份证上的月份
          year = parseInt(idCard?.substr(6, 4)) //身份证上的年份
          day = parseInt(idCard?.substr(12, 2)) //身份证上的日期
          birthday = moment(idCard?.substr(6, 8)).format(DateTimeFormatSimple)
          // 通过身份证倒数第二位判断男女 奇数男 偶数女
          form.setFieldsValue({
            sex: sex,
          })
        } else if (idCard.length === 15 || idCard.length === 16) {
          //16位示例3305229603021031，少了两位年份
          //15位示例330522960302103，少了两位年份，最后的序号是3位
          month = parseInt(idCard?.substr(8, 2)) //身份证上的月份
          year = parseInt('19' + idCard?.substr(6, 2)) //身份证上的年份
          day = parseInt(idCard?.substr(10, 2)) //身份证上的日期
          birthday = moment('19' + idCard?.substr(6, 6)).format(
            DateTimeFormatSimple
          )
          form.setFieldsValue({
            sex: sex,
          })
        }
        if (
          (idCard.length != 18 && idCard.length != 16 && idCard.length != 15) ||
          idCard === ''
        ) {
          form.setFieldsValue({
            ageYear: '',
            age: '',
            ageMonth: '',
            ageDay: '',
            birthday: '',
            sex: 0,
          })
          setAgeYear('')
          setAgeMonth('')
          setAgeDay('')
        } else {
          let ageYear = 0
          let ageMonth = 0
          if (getMonth - month > 0) {
            ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
            ageMonth = getMonth - month
            if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
          } else if (getMonth - month < 0) {
            ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
            ageMonth = 12 - (month - getMonth)
            if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
          } else if (getMonth - month === 0) {
            if (getDay < day) {
              ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
              ageMonth = 11
            } else {
              ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
              ageMonth = 0
            }
          }
          const totalMonths = ageYear * 12 + ageMonth
          if (totalMonths < 12) {
            // 小于1岁，使用月/天模式
            // setAgeUnit('month')
            // 计算剩余天数
            let ageDayValue = moment().diff(moment(birthday).add(totalMonths, 'months'), 'days')
            // 防止天数计算出负（溢出到下一个月）
            if (ageDayValue < 0 && totalMonths > 0) {
              ageDayValue = moment().diff(moment(birthday).add(totalMonths - 1, 'months'), 'days')
              form.setFieldsValue({
                ageMonth: totalMonths - 1 <= 0 ? 0 : totalMonths - 1,
                ageDay: ageDayValue,
                birthday: birthday,
              })
              setAgeYear(0)
              setAgeMonth(totalMonths - 1 <= 0 ? 0 : totalMonths - 1)
              setAgeDay(ageDayValue)
            } else {
              form.setFieldsValue({
                ageMonth: totalMonths <= 0 ? 0 : totalMonths,
                ageDay: ageDayValue,
                birthday: birthday,
              })
              setAgeYear(0)
              setAgeMonth(totalMonths <= 0 ? 0 : totalMonths)
              setAgeDay(ageDayValue)
            }
          } else {
            // 大于等于1岁，使用岁/月模式
            // setAgeUnit('year')
            form.setFieldsValue({
              ageYear: ageYear < 0 ? 1 : ageYear,
              age: ageYear < 0 ? 1 : ageYear,
              ageMonth: ageMonth <= 0 ? 0 : ageMonth,
              birthday: birthday,
            })
            setAgeYear(ageYear < 0 ? 1 : ageYear)
            setAgeMonth(ageMonth <= 0 ? 0 : ageMonth)
            setAgeDay(0)
          }
        }
      }
    } else {
      setIdCardInputValid(false)
    }
  }

  // ========== 核心改造：提交表单后的处理逻辑 ==========
  const handleSubmit = async (values: any) => {
    setBtnLoading(true)
    // 反查选中的人员姓名（审方药师/调配人员/发药人，Select 只存了 id）
    const reviewerPharmacist = users?.find(
      (u: any) => Number(u.id) === values.reviewerPharmacistId
    )
    const allocateUser = users?.find(
      (u: any) => Number(u.id) === values.allocateUserId
    )
    const shipmentsUser = users?.find(
      (u: any) => Number(u.id) === values.shipmentsId
    )

    const submitData = {
      // 申请渠道 -> 互联网医院编码
      channelName: values.channelName,
      patient: {
        id: selectedPatientId,
        name: values.name,
        birthday: values.birthday
          ? moment(values.birthday).format('YYYY/MM/DD')
          : undefined,
        ageYear: ageYears,
        ageMonth: ageMonths,
        ageDay: ageDays,
        sex: sex,
        phone: values?.phone == getMaskPhone(values?.phone) ? maskInfo?.phone : values?.phone || '',
        idCardNumber: values?.idCardNumber == getMaskIdCard(values?.idCardNumber) ? maskInfo?.idCardNumber : values?.idCardNumber || '',
        provinceCode: values.area?.[0],
        cityCode: values.area?.[1],
        contryCode: values.area?.[2],
        address: values.address,
        // companyName: patientObj?.companyName,
        // emergencyContactName: patientObj?.emergencyContactName,
        // emergencyContactPhone: patientObj?.emergencyContactPhone,
      },
      treatment: {
        disease: selectedDiseases?.map((d) => `${d.name}/${d.icds}`).join(','),
        diseaseCode: selectedDiseases?.map((v) => v.icds)?.join(','),
        reviewerPharmacistId: values.reviewerPharmacistId,
        reviewerPharmacistName: reviewerPharmacist?.realname,
        reviewerPharmacistIdCardNumber: values.reviewerPharmacistIdCardNumber,
        reviewerPharmacistPhone: values.reviewerPharmacistPhone,
        allocateUserId: values.allocateUserId,
        allocateUserName: allocateUser?.realname,
        shipmentsId: values.shipmentsId,
        shipmentsName: shipmentsUser?.realname,
        historyOfPresentIllness: values.historyOfPresentIllness ? values.historyOfPresentIllness : selectedDiseases?.map((v) => v.name)?.join(','),
        pastMedicalHistory: values.pastMedicalHistory,
        allergen: values.allergen,
        physicalExamination: values.physicalExamination,
        patientHeight: values.patientHeight,
        patientWeight: values.patientWeight,
        patientTemperature: values.patientTemperature,
        patientPulse: values.patientPulse,
        patientSystolicPressure: values.patientSystolicPressure,
        patientDiastolicPressure: values.patientDiastolicPressure,
        precautions: values.precautions,
        remark: values.remark,
      },
    }

    //1. 关闭在线申请主弹窗，打开申请进度弹窗
    // 标记：本次关闭主弹窗不重置表单，提交失败后"立即修改"需保留已填内容
    preserveFormRef.current = true
    onCancel()
    setShowApplyProgressModal(true)
    setProgressPercent(0)

    //模拟进度条缓慢上涨，不会到100，等接口回来直接置100
    const progressTimer = setInterval(() => {
      setProgressPercent(prev => {
        if (prev >= 90) return prev
        return prev + Math.floor(Math.random() * 6)
      })
    }, 300)

    try {
      //调用父组件传过来的处方申请接口
      const res = await onOk(submitData)

      // 第三方回传的处方笺 base64（兼容顶层或 data 字段）
      const pdfBase64 = res?.base64PdfStr || res?.data?.base64PdfStr || ''
      const prescriptionNo = res?.prescriptionNo || res?.data?.prescriptionNo || ''
      const auditType = res?.auditType || res?.data?.auditType || ''
      //请求成功，缓存本次选择的人员，供下次打开默认回填
      clearInterval(progressTimer)
      setProgressPercent(100)
      //稍微延时模拟完成动画
      setTimeout(() => {
        setShowApplyProgressModal(false)
        setPrescriptionPdfBase64(pdfBase64)
        setPrescriptionNo(prescriptionNo)

        if (auditType == '0') {
          // 人工审核打开审核弹窗
          setShowPrescriptionAuditModal(true)
        } else {
          // 自动审核打开处方详情弹窗
          setShowPrescriptionDetailModal(true) //打开处方详情弹窗
        }
        preserveFormRef.current = false
        form.resetFields()
        setSelectedDiseases([])
        setDisable(false)
        setKeyword('')
        setSelectedPatientId(undefined)
        onApplyResult?.(false)
      }, 400)

    } catch (err) {
      //请求失败，拿到后端返回的错误原因
      clearInterval(progressTimer)
      setShowApplyProgressModal(false)
      setFailReason(err?.message || err?.msg || "")
      setShowFailModal(true)
      onApplyResult?.(true)
    } finally {
      setBtnLoading(false)
    }
  }

  // 失败弹窗【立即修改】：关闭失败弹窗回到当前页面，清理数据；下次点击预结算时通过详情接口回填
  const handleFailEdit = () => {
    preserveFormRef.current = false
    form.resetFields()
    setSelectedDiseases([])
    setDisable(false)
    setKeyword('')
    setSelectedPatientId(undefined)
    setIsPatientOverlayVisible(false)
    setShowFailModal(false)
  }

  // 失败弹窗【取消】：关闭失败弹窗，清理保留的表单数据
  const handleFailCancel = () => {
    preserveFormRef.current = false
    form.resetFields()
    setSelectedDiseases([])
    setDisable(false)
    setKeyword('')
    setSelectedPatientId(undefined)
    setIsPatientOverlayVisible(false)
    setShowFailModal(false)
  }

  // 处方详情弹窗【预结算】：点击按钮或按空格触发
  const handlePreSettle = () => {
    if (payLoading) {
      return
    }
    setPayLoading(true)
    handlePay()
    setTimeout(() => setPayLoading(false), 500)
  }

  // 处方详情弹窗展示时，空格键触发「预结算(空格)」
  useEffect(() => {
    if (!showPrescriptionDetailModal) {
      return
    }
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.isComposing || e.code !== 'Space') {
        return
      }
      const target = e.target as HTMLElement
      if (
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable)
      ) {
        return
      }
      e.preventDefault()
      handlePreSettle()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [showPrescriptionDetailModal, payLoading])

  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients?.map((p) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            form.setFieldsValue({
              name: p.name,
              phone: p.phone ? (!KSKDCKHRSJHData ? getMaskPhone(p.phone) : p.phone) : '',
              idCardNumber: p.idCardNumber ? (!KSKDCKHRSFZHData ? getMaskIdCard(p.idCardNumber) : p.idCardNumber) : '',
              sex: p.sex || 1,
              birthday: p.birthday,
              area: p.provinceCode
                ? [Number(p.provinceCode), Number(p.cityCode), Number(p.contryCode)]
                : undefined,
              address: p.address,
            })
            setMaskInfo({
              phone: p.phone,
              phoneDisabled: p.phone && !KSKDCKHRSJHData,
              idCardNumber: p.idCardNumber,
              idCardNumberDisabled: p.idCardNumber && !KSKDCKHRSFZHData,
            })
            setSex(p.sex)
            setAgeYear(p.ageYear)
            setAgeMonth(p.ageMonth)
            setDisable(true)
            setSelectedPatientId(p.id)
            setIsPatientOverlayVisible(false)
            setKeyword(p.name)
          }}
        >
          <Space>
            <span>{p.name}</span>
            <span>{getGenderName(p.sex)}</span>
            <span>{getAge(p.ageYear, p.ageMonth, '岁', p.ageDay)}</span>
            <span>{p.phone}</span>
            <span>{p.id}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  useEffect(() => {
    //获取省市数据
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllList(res)
      })

    dispatch(getPrintTemplateSettingUserList({ stationType: 2, state: 1 }))
      .then(unwrapResult)
      .then((users: any) => {
        setUsers(users)
      })
      .catch(() => {
        // do nothing.
      })
  }, [])

  const getPatientDetail = (patientIdValue: any) => {
    if (patientIdValue) {
      dispatch(getPatientPageInfo(String(patientIdValue)))
        .then(unwrapResult)
        .then((detail: any) => {
          if (detail?.id != null) {
            form.setFieldsValue({
              idCardNumber: detail?.idCardNumber
                ? (!KSKDCKHRSFZHData ? getMaskIdCard(detail?.idCardNumber) : detail?.idCardNumber)
                : '',
              area: detail?.provinceCode
                ? [Number(detail.provinceCode), Number(detail.cityCode), Number(detail.contryCode)]
                : [provinceCode, cityCode, countyCode],
              address: detail?.address,
            })
            setMaskInfo((prev: any) => ({
              ...prev,
              idCardNumber: detail?.idCardNumber,
              idCardNumberDisabled: detail?.idCardNumber && !KSKDCKHRSFZHData,
            }))
            if (detail?.idCardNumber) {
              getIdCardInfo(detail?.idCardNumber)
            }
          }
        })
        .catch(() => {
          // 详情拉取失败时保留现有回填
        })
    }
  }
  // patientObj 有值时，先回填页面的患者信息；诊断（疾病）已填写的话也一并回填
  useEffect(() => {
    console.log('visiblevisible', patientObj, detailData)
    if (visible) {
      // 详情接口有数据时，优先用详情数据回填（失败后重新申请）
      if (detailData?.order) {
        const order = detailData.order
        const treatment = detailData.treatment || {}
        // 回填疾病（详情 disease 形如 "高血压/I10,糖尿病/E11"）
        const diseaseItems = (treatment?.disease || '').split(',').filter((s: string) => s)
        const diseaseCodes = (treatment?.diseaseCode || '').split(',').filter((s: string) => s)
        const diseases = diseaseItems.map((item: string, i: number) => ({
          name: item?.split('/')[0]?.trim(),
          icds: diseaseCodes[i],
        }))
        setSelectedDiseases(diseases)

        const sexValue =
          order?.sex === '女' || Number(order?.sex) === Gender.Female
            ? Gender.Female
            : Gender.Male

        setDisable(true)
        form.setFieldsValue({
          name: order?.patientName,
          phone: order?.phone ? (!KSKDCKHRSJHData ? getMaskPhone(order?.phone) : order?.phone) : '',
          idCardNumber: order?.idCard ? (!KSKDCKHRSFZHData ? getMaskIdCard(order?.idCard) : order?.idCard) : '',
          sex: sexValue,
          birthday: order?.patientBirthday,
          reviewerPharmacistId: order?.reviewerPharmacistId != null ? Number(order?.reviewerPharmacistId) : undefined,
          reviewerPharmacistIdCardNumber: order?.reviewerPharmacistIdCardNumber,
          reviewerPharmacistPhone: order?.reviewerPharmacistPhone,
          allocateUserId: order?.allocateUserId != null ? Number(order?.allocateUserId) : undefined,
          shipmentsId: order?.shipmentsId != null ? Number(order?.shipmentsId) : undefined,
          historyOfPresentIllness: treatment?.chiefComplaint,
          pastMedicalHistory: treatment?.pastMedicalHistory,
          allergen: treatment?.allergen,
          physicalExamination: treatment?.physicalExamination,
          patientHeight: treatment?.patientHeight,
          patientWeight: treatment?.patientWeight,
          patientTemperature: treatment?.patientTemperature,
          patientPulse: treatment?.patientPulse,
          patientSystolicPressure: treatment?.patientSystolicPressure,
          patientDiastolicPressure: treatment?.patientDiastolicPressure,
          precautions: order?.precautions,
          remark: order?.remark,
        })
      
        setMaskInfo({
          phone: order?.phone,
          phoneDisabled: order?.phone && !KSKDCKHRSJHData,
          idCardNumber: order?.idCard,
          idCardNumberDisabled: order?.idCard && !KSKDCKHRSFZHData,
        })
        setKeyword(order?.patientName || '')
        setSelectedPatientId(order?.patientId)
        setSex(sexValue)
        // patientObj 仅含页面展示字段，缺少身份证号/家庭地区/详细地址，
        // 用患者 id 拉详情补齐这三个字段的回填
        const patientIdValue = order?.patientId 
        getPatientDetail(patientIdValue)
        return
      }
      if (patientObj && Object.keys(patientObj).length) {
        const patientName = patientObj?.name || patientObj?.patientName
        setDisable(patientName ? true : false)
        form.setFieldsValue({
          name: patientName,
          phone: patientObj?.phone ? (!KSKDCKHRSJHData ? getMaskPhone(patientObj?.phone) : patientObj?.phone) : '',
          idCardNumber: patientObj?.idCardNumber ? (!KSKDCKHRSFZHData ? getMaskIdCard(patientObj?.idCardNumber) : patientObj?.idCardNumber) : '',
          sex: patientObj?.patientSex || 1,
          birthday: patientObj?.birthday,
          area: patientObj?.provinceCode
            ? [Number(patientObj.provinceCode), Number(patientObj.cityCode), Number(patientObj.contryCode)]
            : [provinceCode, cityCode, countyCode],
          address: patientObj?.address,
          allocateUserId: Number(users?.[0]?.id),
          shipmentsId: Number(users?.[0]?.id),
          reviewerPharmacistId: Number(users?.[0]?.id),
          reviewerPharmacistIdCardNumber: users?.[0]?.identityCard || '',
          reviewerPharmacistPhone: users?.[0]?.phone || '',
        })
        setMaskInfo({
          phone: patientObj?.phone,
          phoneDisabled: patientObj?.phone && !KSKDCKHRSJHData,
          idCardNumber: patientObj?.idCardNumber,
          idCardNumberDisabled: patientObj?.idCardNumber && !KSKDCKHRSFZHData,
        })
        if (patientObj?.idCardNumber) {
          getIdCardInfo(patientObj?.idCardNumber)
        }
        setKeyword(patientName || '')
        setSelectedPatientId(patientObj?.patientId || patientObj?.id || patientId)
        setSex(patientObj?.sex)
        setAgeYear(patientObj?.ageYear)
        setAgeMonth(patientObj?.ageMonth)
        // 诊断页面已填写疾病的话，回填疾病
        const diseaseList = patientObj?.disease
             ?.split(',')
             ?.map((d: any) => d?.split('/'))
             ?.map((pair: any) => ({ name: pair[0], icds: pair[1] } as Disease))
        if (patientObj?.selectedDiseasesZIFEI?.length || diseaseList?.length) {
          setSelectedDiseases(patientObj.selectedDiseasesZIFEI || diseaseList)
        }
        // patientObj 仅含页面展示字段，缺少身份证号/家庭地区/详细地址，
        // 用患者 id 拉详情补齐这三个字段的回填
        const patientIdValue = patientObj?.patientId || patientObj?.id || patientId 
        getPatientDetail(patientIdValue)
       
      } else {
        form.setFieldsValue({
          sex: 1,
          area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
          allocateUserId: Number(users?.[0]?.id),
          shipmentsId: Number(users?.[0]?.id),
          reviewerPharmacistId: Number(users?.[0]?.id),
          reviewerPharmacistIdCardNumber: users?.[0]?.identityCard || '',
          reviewerPharmacistPhone: users?.[0]?.phone || '',
        })
      }
    }
  }, [visible, patientObj, users?.length, detailData])

  useEffect(() => {
    if (!visible) {
      // 提交失败流程中（preserveFormRef 为 true）保留表单数据，跳过重置
      if (preserveFormRef.current) {
        return
      }
      form.resetFields()
      setDisable(false)
      setKeyword('')
      setSelectedPatientId(undefined)
      setIsPatientOverlayVisible(false)
      setSelectedDiseases([])
      setMaskInfo({})
      setSex(undefined)
      setAgeYear(undefined)
      setAgeMonth(undefined)
      setAgeDay(undefined)
      setIdCardInputValid(false)
      setPatientSystolicPressureValue(undefined)
      setPatientDiastolicPressureValue(undefined)
      setFailReason('')
      setPrescriptionPdfBase64('')
      setProgressPercent(0)
      setBtnLoading(false)
    }
  }, [visible])

  useEffect(() => {
    if (showPrescriptionAuditModal) {
      Auditform.setFieldsValue({
        status: 1,
        auditPharmacistId: form.getFieldValue('reviewerPharmacistId'),
      })
    }
  }, [showPrescriptionAuditModal])

  return (
    <>
      <Modal
        visible={visible}
        title="在线申请处方"
        width={1130}
        maskClosable={false}
        cancelText="取消"
        okText="提交"
        confirmLoading={btnLoading}
        onCancel={onCancel}
        onOk={form.submit}
        wrapClassName={styles.modalWrap}
      >
        <Form
          form={form}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          {/* ========== 申请渠道 ========== */}
          <>
            <Row style={{ fontWeight: 600, fontSize: 15, marginBottom: 12 }}>申请渠道</Row>
            <Row>
              <Col span={8} >
                <Form.Item {...layout} label="渠道名称" name="channelName" initialValue="KJ" rules={[{ required: true }]}>
                  <Radio.Group>
                    {internetChannelConfig?.split(',')?.map((item: any) => (
                      <Radio value={item} key={item}>{getChannelName(item)}</Radio>
                    ))}
                    {/* <Radio value={'KJ'} key={'KJ'}>康久互联网医院</Radio> */}
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </>

          {/* ========== 患者信息 ========== */}
          <Row style={{ fontWeight: 600, fontSize: 15, margin: "0px 0 12px" }}>患者信息</Row>
          <Row>
            <Col span={8} style={{ position: 'relative' }}>
              <Form.Item {...layout} label="患者姓名" name="name" rules={[{ required: true }]}>
                <Dropdown
                  overlay={patientOverlay}
                  visible={isPatientOverlayVisible}
                  disabled={disable || idCardInputValid}
                >
                  <Input
                    style={{ width: '180px' }}
                    autoFocus
                    allowClear
                    placeholder={'姓名/性别/手机号'}
                    prefix={
                      <SearchOutlined
                        style={{ color: theme.tc3 }}
                      />
                    }
                    value={keyword}
                    onFocus={() => {
                      dispatch(
                        getPatientList(keyword)
                      )
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setIsPatientOverlayVisible(
                          false
                        )
                      }, 300)
                    }}
                    onClick={() => {
                      setIsPatientOverlayVisible(true)
                    }}
                    onChange={(e) => {
                      setIsPatientOverlayVisible(true)
                      setKeyword(e.target.value)
                      form.setFieldsValue({ name: e.target.value })
                      setSelectedPatientId(undefined)
                    }}
                  />
                </Dropdown>
              </Form.Item>
              <Button
                style={{
                  padding: 0,
                  marginLeft: 8,
                  position: 'absolute',
                  top: 0,
                  right: 0,
                }}
                type='link'
                onClick={() => {
                  setKeyword('')
                  setDisable(false)
                  setIdCardInputValid(false)
                  setSelectedPatientId(undefined)
                  form.setFieldsValue({
                    name: '',
                    phone: '',
                    idCardNumber: '',
                    sex: 1,
                    birthday: '',
                    area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
                    address: ''
                  })
                }}
              >
                清空
              </Button>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="联系方式" name="phone"
                rules={[
                  { required: true, pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "手机号格式错误" }
                ]}
              >
                <Input
                  allowClear
                  placeholder="请输入"
                  disabled={maskInfo?.phoneDisabled}
                  suffix={
                    maskInfo?.phoneDisabled ? (
                      <CloseCircleFilled
                        onClick={() => {
                          form.setFieldsValue({ phone: '' })
                          setMaskInfo({
                            ...maskInfo,
                            phone: '',
                            phoneDisabled: false,
                          })
                        }}
                        style={{ color: '#999', cursor: 'pointer' }}
                      />
                    ) : null
                  } />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="身份证号" name="idCardNumber" rules={[
                ...idCardRules,
                { required: true, message: '请输入身份证号' }
              ]} >
                <Input allowClear placeholder="请输入"
                  onBlur={() => getIdCardInfo(form.getFieldValue('idCardNumber'))}
                  disabled={maskInfo?.idCardNumberDisabled}
                  suffix={
                    maskInfo?.idCardNumberDisabled ? (
                      <CloseCircleFilled
                        onClick={() => {
                          form.setFieldsValue({ idCardNumber: '' })
                          setMaskInfo({
                            ...maskInfo,
                            idCardNumber: '',
                            idCardNumberDisabled: false,
                          })
                        }}
                        style={{ color: '#999', cursor: 'pointer' }}
                      />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8} >
              <Form.Item {...layout} label="性别" name="sex" rules={[{ required: true }]}>
                <Radio.Group disabled={disable || idCardInputValid}>
                  {[
                    Gender.Male,
                    Gender.Female,
                  ].map((g) => (
                    <Radio key={g} value={g}>
                      {getGenderName(g)}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label="出生年月" name="birthday" rules={[{ required: true }]}>
                <Input allowClear placeholder="请输入" disabled={disable || idCardInputValid} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8} >
              <Form.Item {...layout} label="家庭地区" name="area">
                <Cascaded
                  allowClear={true}
                  options={allList}
                  placeholder='请选择'
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="详细地址" name="address">
                <Input allowClear placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>

          {/* ========== 就诊信息 ========== */}
          <Row style={{ fontWeight: 600, fontSize: 15, margin: "20px 0 12px" }}>就诊信息</Row>
          <Row>
            <Col span={8} >
              <Form.Item
                {...layout}
                label="诊断"
                name="disease"
                rules={[
                  {
                    required: true,
                    validator: () =>
                      selectedDiseases?.length
                        ? Promise.resolve()
                        : Promise.reject(new Error('请选择疾病')),
                  },
                ]}
              >
                <DiseaseInput
                  isMedical={1}
                  placeholder="请选择"
                  autoFocus={selectedDiseases?.length ? true : false}
                  onSelect={(disease) => {
                    if (
                      !selectedDiseases.find(
                        (d) => d?.icds === disease?.icds
                      )
                    ) {
                      setSelectedDiseases(
                        selectedDiseases.concat(
                          disease
                        )
                      )
                      form.resetFields(['disease'])
                    }
                  }}
                  style={{ width: '100%' }}
                />
              </Form.Item>

            </Col>
            <Col span={16}>
              <div style={{ paddingLeft: 10, display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                {selectedDiseases.map((d) => (
                  <div key={d.icds} style={{ display: 'inline-block', backgroundColor: '#f4f8fb', padding: '4px 6px', margin: '0 10px 10px 0', borderRadius: 3 }}>
                    {d.name}
                    <CloseOutlined onClick={() => setSelectedDiseases(selectedDiseases.filter(i => i.icds !== d.icds))} style={{ cursor: 'pointer', marginLeft: 4 }} />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} >
              <Form.Item {...layout} label="审方药师" name="reviewerPharmacistId" rules={[{ required: true }]}>
                <Select
                  placeholder='请选择'
                  onChange={(value: number) => {
                    const user = users?.find((u: any) => Number(u.id) === value)
                    form.setFieldsValue({
                      reviewerPharmacistIdCardNumber: user?.identityCard || '',
                      reviewerPharmacistPhone: user?.phone || '',
                    })
                  }}
                >
                  {users?.map((u: any) => (
                    <Select.Option key={Number(u.id)} value={Number(u.id)}>
                      {u.realname}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="审方药师身份证号" name="reviewerPharmacistIdCardNumber"
                rules={[
                  {
                    pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                    message: "您的身份证格式不正确",
                  },
                  {
                    max: 18,
                    message: "最长18位!",
                  },
                ]}>
                <Input allowClear placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="审方药师电话" name="reviewerPharmacistPhone" rules={[
                { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "手机号格式错误" }
              ]}>
                <Input allowClear placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="调配人员" name="allocateUserId">
                <Select placeholder='请选择医生'>
                  {users?.map((u: any) => (
                    <Select.Option key={Number(u.id)} value={Number(u.id)}>
                      {u.realname}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item {...layout} label="发药人" name="shipmentsId">
                <Select placeholder='请选择'>
                  {users?.map((u: any) => (
                    <Select.Option key={Number(u.id)} value={Number(u.id)}>
                      {u.realname}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} >
              <Form.Item {...layouts} label="主诉" name="historyOfPresentIllness">
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layouts} label="既往史" name="pastMedicalHistory">
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layouts} label="过敏史" name="allergen">
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label='体格检查'
                name=''
                {...layouts}
              >
                <Row
                  style={{ height: 32, position: 'relative' }}
                  className={styles.checkGroup}
                >
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      noStyle
                      name='patientTemperature'
                      rules={[
                        {
                          message: '请输入最多带一位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]?)?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={4}
                        addonAfter='℃'
                        placeholder='体温'
                        onChange={(v) => {
                          const value = v?.target?.value
                          if (!deleteFlag) {
                            if (value.indexOf('.') !== -1) {
                              form.setFieldsValue({
                                patientTemperature: value,
                              })
                            } else {
                              if (value?.length == 2) {
                                form.setFieldsValue({
                                  patientTemperature: value + '.',
                                })
                              } else if (value?.length == 3) {
                                form.setFieldsValue({
                                  patientTemperature:
                                    value.slice(0, 2) + '.' + value.slice(2),
                                })
                              } else {
                                form.setFieldsValue({
                                  patientTemperature: value,
                                })
                              }
                            }
                          }
                          if (v?.target?.value?.length == 4) {
                            if (/(\.\.)/.test(value)) {
                              form.setFieldsValue({
                                patientTemperature: value.slice(
                                  0,
                                  value?.length - 1
                                ),
                              })
                            } else {
                              patientSystolicPressureRef?.current?.focus()
                            }
                          }
                        }}
                        onPressEnter={(v) => {
                          patientSystolicPressureRef?.current?.focus()
                          const value = form.getFieldValue(
                            'patientTemperature'
                          )
                          if (value?.length == 3 && value.indexOf('.') !== -1) {
                            form.setFieldsValue({
                              patientTemperature: value.slice(0, 2),
                            })
                          }
                        }}
                        onBlur={() => {
                          const value = form.getFieldValue(
                            'patientTemperature'
                          )
                          if (value?.length == 3 && value.indexOf('.') !== -1) {
                            form.setFieldsValue({
                              patientTemperature: value.slice(0, 2),
                            })
                          }
                        }}
                        onKeyDown={(e) => {
                          // 允许使用 Backspace 和 Delete 键进行删除
                          if (e.key === 'Backspace' || e.key === 'Delete') {
                            setDeleteFlag(true)
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Row style={{ width: '28%' }}>
                    <Col style={{ width: '36%' }}>
                      <Form.Item
                        name='patientSystolicPressure'
                        rules={[
                          {
                            message: '请输入整数值',
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}
                      >
                        <Input
                          className={
                            Number(patientSystolicPressureValue) > 140 ||
                              Number(
                                form?.getFieldValue(
                                  'patientSystolicPressure'
                                )
                              ) > 140
                              ? styles.textColore47a1f
                              : styles.textColor
                          }
                          maxLength={3}
                          placeholder='收缩压'
                          ref={patientSystolicPressureRef}
                          onChange={(v) => {
                            setPatientSystolicPressureValue(v?.target?.value)
                            if (v?.target?.value?.length == 3) {
                              patientDiastolicPressureRef?.current?.focus()
                            }
                          }}
                          onPressEnter={() => {
                            patientDiastolicPressureRef?.current?.focus()
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      style={{
                        padding: '5px 5px 0 5px',
                      }}
                    >
                      /
                    </Col>
                    <Col
                      style={{ flex: 1 }}
                      className={
                        Number(patientDiastolicPressureValue) > 90 ||
                          Number(
                            form?.getFieldValue(
                              'patientDiastolicPressure'
                            )
                          ) > 90
                          ? styles.textColore47a1fContent
                          : styles.textColor
                      }
                    >
                      <Form.Item
                        name='patientDiastolicPressure'
                        rules={[
                          {
                            message: '请输入整数值',
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}
                      >
                        <Input
                          maxLength={3}
                          addonAfter='mmHg'
                          placeholder='舒张压'
                          ref={patientDiastolicPressureRef}
                          onChange={(v) => {
                            setPatientDiastolicPressureValue(v?.target?.value)
                            if (v?.target?.value?.length == 3) {
                              patientPulseRef?.current?.focus()
                            }
                          }}
                          onPressEnter={() => {
                            patientPulseRef?.current?.focus()
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Col style={{ width: '14%' }}>
                    <Form.Item
                      name='patientPulse'
                      rules={[
                        {
                          message: '请输入整数值',
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={3}
                        addonAfter='次/分'
                        placeholder='脉搏'
                        ref={patientPulseRef}
                        onChange={(v) => {
                          if (v?.target?.value?.length == 3) {
                            patientHeightRef?.current?.focus()
                          }
                        }}
                        onPressEnter={() => {
                          patientHeightRef?.current?.focus()
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      name='patientHeight'
                      rules={[
                        {
                          message: '请输入最多带两位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={5}
                        addonAfter='cm'
                        placeholder='身高'
                        onChange={async (e) => {
                          const v = e.target.value
                          if (v?.length == 3) {
                            patientWeightRef?.current?.focus()
                          }
                        }}
                        ref={patientHeightRef}
                        onPressEnter={() => {
                          patientWeightRef?.current?.focus()
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      name='patientWeight'
                      rules={[
                        {
                          message: '请输入最多带两位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={5}
                        addonAfter='kg'
                        placeholder='体重'
                        onPressEnter={() => {
                          otherPhysicalRef?.current?.focus()
                        }}
                        ref={patientWeightRef}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '19%' }}>
                    <Form.Item name="physicalExamination">
                      <Input allowClear placeholder="其他体格检查" ref={otherPhysicalRef} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...layouts} label="注意事项" name="precautions">
                <Input placeholder="注意事项" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layouts} label="备注" name="remark">
                <TextArea rows={3} placeholder="备注" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal >

      {/* ==========弹窗1：处方申请中进度弹窗 ========== */}
      < Modal
        visible={showApplyProgressModal}
        title="处方申请"
        footer={null}
        closable={false}
        maskClosable={false}
        width={520}
      >
        <div style={{ padding: "24px 12px", textAlign: "center" }}>
          <Progress percent={progressPercent} status="active" strokeColor="#4DBD16" trailColor="#E4EEDF" />
          <div style={{ marginTop: 16 }}>处方申请中，请稍等</div>
        </div>
      </Modal >

      {/* ==========申请不通过失败弹窗 ========== */}
      < Modal
        visible={showFailModal}
        title="申请不通过"
        maskClosable={false}
        onCancel={handleFailCancel}
        footer={
          <>
            <button className="ant-btn" onClick={handleFailCancel}>取消</button>
            <button className="ant-btn ant-btn-primary" onClick={handleFailEdit}>立即修改</button>
          </>
        }
        width={520}
      >
        <div style={{ color: 'red' }}>原因：{failReason}</div>
      </Modal >

      {/* ==========处方申请弹窗 ========== */}
      < Modal
        visible={showPrescriptionDetailModal}
        title="处方详情"
        maskClosable={false}
        width={800}
        onCancel={() => {
          setShowPrescriptionDetailModal(false)
          onClose && onClose()
        }}
        footer={
          <>
            <Button
              className="ant-btn"
              onClick={() => {
                setShowPrescriptionDetailModal(false)
                onClose && onClose()
              }}>取消</Button>
            <Button
              className="ant-btn ant-btn-primary"
              onClick={handlePreSettle}
              loading={payLoading}
            >
              预结算(空格)
            </Button>
          </>
        }
      >
        {prescriptionPdfBase64 ? (
          <iframe
            src={`data:application/pdf;base64,${prescriptionPdfBase64}#view=Fit&toolbar=0&navpanes=0`}
            width="100%"
            height="500px"
            style={{ border: 'none' }}
          />
        ) : (
          <div style={{ width: '60%', height: '500px', background: '#f5f7fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            第三方回传的处方笺
          </div>
        )}
      </Modal >

      {/* ==========处方审核弹窗 ========== */}
      < Modal
        visible={showPrescriptionAuditModal}
        title="处方审核"
        maskClosable={false}
        width={800}
        className={styles.prescriptionAuditModal}
        onCancel={() => setShowPrescriptionAuditModal(false)}
        footer={null}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ width: '60%' }}>
            {prescriptionPdfBase64 ? (
              <iframe
                src={`data:application/pdf;base64,${prescriptionPdfBase64}#view=Fit&toolbar=0&navpanes=0`}
                width="100%"
                height="500px"
                style={{ border: 'none' }}
              />
            ) : (
              <div style={{ width: '100%', height: '500px', background: '#f5f7fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                第三方回传的处方笺
              </div>
            )}
          </div>
          <div style={{ width: '40%', paddingLeft: '25px' }}>
            <Form form={Auditform} layout="vertical"
              onFinish={((v) => {
                setButtonLoading(true)
                const auditPharmacistName = users?.find(
                  (u: any) => Number(u.id) === v?.auditPharmacistId
                )
                dispatch(getPrescriptionAuditAsync({
                  prescriptionNo: prescriptionNo,
                  status: v?.status,
                  auditPharmacistId: v?.auditPharmacistId,
                  auditPharmacistName: auditPharmacistName?.realname || '',
                  reason: v?.reason,
                }))
                  .then(unwrapResult)
                  .then(() => {
                    setButtonLoading(false)
                    setShowPrescriptionAuditModal(false)
                    if (v?.status == 1) {
                      // 通过：打开处方详情弹窗
                      setTimeout(() => {
                        setShowPrescriptionDetailModal(true)
                      }, 300)
                    } else {
                      // 不通过：置失败标志，下次申请时调详情接口回填
                      onApplyResult?.(true)
                    }
                  })
                  .catch(() => {
                    setButtonLoading(false)
                    setShowPrescriptionAuditModal(false)
                    if (v?.status != 1) {
                      onApplyResult?.(true)
                    }
                  })
              })}>
              <Col span={24}>
                <Form.Item label="审方药师" name="auditPharmacistId" rules={[{ required: true, message: '请选择审方药师' }]}>
                  <Select
                    placeholder='请选择'
                  >
                    {users?.map((u: any) => (
                      <Select.Option key={Number(u.id)} value={Number(u.id)}>
                        {u.realname}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="审方结果" name="status" rules={[{ required: true, message: '请选择审方结果' }]} >
                  <Radio.Group style={{ width: '100%', display: 'flex', justifyContent: 'flex-start',alignItems:'center' }}>
                    <Radio key={1} value={1} style={{width:'30%'}}>
                      通过
                    </Radio>
                    <Radio key={2} value={2}>
                      不通过
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24} style={{ marginTop: '-4px' }}>
                <Form.Item label="备注" name="reason">
                  <TextArea rows={4} maxLength={100} showCount></TextArea>
                </Form.Item>
              </Col>
              <Row style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '40px' }}>
                <Button style={{ marginRight: '10px' }} onClick={() => setShowPrescriptionAuditModal(false)}>取消</Button>
                <Button type="primary" htmlType="submit" loading={buttonLoading}>确认</Button>
              </Row>
            </Form>
          </div>
        </div>
      </Modal >
    </>
  )
}